import { render, staticRenderFns } from "./SiteStruct.vue?vue&type=template&id=46d9454c"
import script from "./SiteStruct.vue?vue&type=script&lang=js"
export * from "./SiteStruct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports